<template>
  <div class="login">
    <a-row>
      <a-col :span="6">
        <img class="logo" src="./../assets/logo_1.png" alt />
      </a-col>
    </a-row>
    <!-- <a-button type="primary">主要按钮</a-button> -->
    <div class="log"></div>
    <a-row>
      <a-col :xs="{ span: 20, offset: 2 }" :md="{ span: 12, offset: 6 }">
        <div class="loginfrom">
          <div class="title">客户信息查询平台</div>
          <a-row class="inputbar">
            <a-col
              class="inputtext"
              :xs="{ span: 8, offset: 0 }"
              :md="{ span: 4, offset: 2 }"
            >
              <i class="a-icon-user"></i>&nbsp;&nbsp;用户名：
            </a-col>
            <a-col :xs="{ span: 14, offset: 0 }" :md="{ span: 12, offset: 1 }">
              <a-input
                @blur="blur"
                v-model="username"
                placeholder="请输入用户名"
              ></a-input>
            </a-col>
          </a-row>
          <a-row class="inputbar">
            <a-col
              class="inputtext"
              :xs="{ span: 8, offset: 0 }"
              :md="{ span: 4, offset: 2 }"
            >
              <i class="a-icon-lock"></i
              >&nbsp;&nbsp;密&nbsp;&nbsp;&nbsp;&nbsp;码：
            </a-col>
            <a-col :xs="{ span: 14, offset: 0 }" :md="{ span: 12, offset: 1 }">
              <a-input
                placeholder="请输入密码"
                v-model="userpwd"
                type="password"
                show-password
                @blur="blur"
              ></a-input>
            </a-col>
          </a-row>
          <a-row class="inputbar">
            <a-col :xs="{ span: 24, offset: 0 }" :md="{ span: 12, offset: 6 }">
              <span class="forget"
                >如果忘记密码，请联系热线电话：4000969899</span
              >
            </a-col>
          </a-row>
          <a-row class="inputbar">
            <a-col :xs="{ span: 24, offset: 0 }" :md="{ span: 12, offset: 6 }">
              <a-spin :spinning="spinning">
                <a-button @click="login" class="logbtn" type="primary" round
                  >确认登录</a-button
                >
              </a-spin>
            </a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
    <!-- <a-modal
      v-model="codeshow"
      title="选择活动编码"
      @ok="selectcodeok"
      @cancel="codeshow = false"
    > -->
      <!-- options="activeCodelist" -->
      <!-- <a-select :default-value="activeCodelist[0]" v-model="activeCode" style="width: 400px" @change="codechange" placeholder="选择活动编码">
        <a-select-option
          v-for="(item, index) in activeCodelist"
          :key="index"
          :value="item"
        >
          {{ item }}
        </a-select-option>
      </a-select>
    </a-modal> -->
  </div>
</template>

<script>
import Axios from "./../Axios";
import infoAction from "@/utils";
export default {
  name: "Login",
  data() {
    return {
      username: "",
      userpwd: "",
      spinning: false,
      codeshow: false,
      activeCode: "",
      activeCodelist: [],
      url: {
        login: "/teacher/yhaTeacher/list",
        getcodelist: "/qrcode/yhaDigitalCode/activeCode",
        trainarrange: "/repcomposer/repComposer/report",
      },
    };
  },
  methods: {
    login() {
      var that = this;
      if (!this.username) {
        this.$message.info("请输入用户名");
        return;
      }
      if (!this.userpwd) {
        this.$message.info("请输入密码");
        return;
      }
      this.spinning = !this.spinning;
      Axios.get(this.url.login, {
        params: {
          username: that.username,
          password: that.userpwd,
        },
      }).then((res) => {
        console.log('---------'+JSON.stringify(res.data.result.records[0].teacherVersion))
        this.$store.dispatch('setTeacherVersion',res.data.result.records[0].teacherVersion)
        if (res.data.code == 200 && res.data.result.total) {
          infoAction.setinfo(
            "userinfo",
            JSON.stringify(res.data.result.records[0])
          );
        // this.isbind()

          // this.searchactivecode();
          this.$message.success("登陆成功");
          that.$router.push("/homepagetwo");
        } else {
          this.$message.warning("用户名或密码错误，请重新输入");
        }
      });
      this.spinning = !this.spinning;
    },
    blur() {
      setTimeout(function () {
        var scrollHeight = window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 查询活动编码列表
    searchactivecode() {
      Axios.get(this.url.getcodelist, {
        params: { universityId: infoAction.getinfo("teacher_info").universityId },
      }).then((res) => {
        if (res.data.code == 200) {
          this.activeCodelist = res.data.result;
          if(this.activeCodelist.length == 1){
            this.activeCode  = res.data.result[0]
            this.selectcodeok()
          }else{
            this.codeshow = true;
          }
        }
      });
      
    },
    // 选择活动编码提交
    // selectcodeok() {
    //   if (this.activeCode) {
    //     infoAction.setinfo("activeCode", this.activeCode);
    //     this.isbind()
    //   } else {
    //     this.$message.info("请选择活动编码");
    //   }
    // },
    // 活动编码改变
    codechange(e) {
      // console.log(typeof e);
      this.activeCode = e;
    },
    // isbind() {
    //   var that = this
    //   Axios.get(this.url.trainarrange, {
    //     params: { 
    //       // activeCode: infoAction.getinfo("activeCode"),
    //       departmentId: 0,
    //       linkName:infoAction.getinfo("teacher_info").name,
    //       universityId:infoAction.getinfo("teacher_info").universityId,
    //       },
    //   }).then(res=>{
    //     if(res.data.code == 200){
    //       this.$message.success("登陆成功");
    //       this.$router.push("/homepage");
    //     }else{
    //       that.$message.info(res.data.message)
    //       // this.$message.info("你没有此活动的浏览权限，请联系管理员")
    //     }
    //   });
    // },
  },
};
</script>

<style scoped>
.login {
  width: 100vw;
  height: 100vh;

  /* margin: 0 auto; */
  /* margin-top: -60px; */
  background-color: #071963;
  /* background-color: aqua; */
}
.logo {
  margin-top: 3vh;
  width: 10vw;
}
.title {
  height: 10vh;
  line-height: 10vh;
  font-size: 22px;
  font-weight: bold;
}
.loginfrom {
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 0px 17px 2px rgba(35, 36, 36, 0.07);
  margin-top: 15%;
  box-sizing: border-box;
  /* height: 400px; */
  padding: 10% 0;
}
.inputbar {
  display: flex;
  align-items: center;
  height: 7vh;
  line-height: 7vh;
}
.inputtext {
  text-align: right;
}
.forget {
  width: 378px;
  height: 19px;
  font-size: 14px;
  font-weight: bold;
  color: blueviolet;
  /* line-height: 70px; */
}
.logbtn {
  width: 80%;
  font-size: 20px;
}
@media screen and (max-width: 768px) {
  .loginfrom {
    margin-top: 10vh;
  }
  .forget {
    height: 19px;
    font-size: 12px;
    font-weight: bold;
    color: #382727;
    /* line-height: 70px; */
  }
  .logo {
    margin-top: 10vh;
    margin-left: 25vw;
    width: 50vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue